import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const ZoomRecording = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            icon:'How_dark',
            label: 'How to access OLE',
            path:'/how_to_access_ole',
        },
        {
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/ashboard'
        },
        {
            icon:'Course_light',
            label: 'Course Page',
            path:'/course_page',
        },
        {
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking_attendance'
        },
        {
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom_recording',
        },
        {
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching_tools',
        }
    ]


    return (
        <div className='MainContainer'>
            <Header/>
            <div className={'MainContent'}>
                <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner'/>
                <div className='MainContentFixBottomLine'></div>
                <div className={'MainContentBox'}>
                    <img className="MainContentTopImage" src={Image.Sub_zoom} alt='banner' />
                    <div className="MainContentTopContain">
                        <span className="MainContentTopText">Zoom Recording</span>
                    </div>
                    <div className={"MainContentMiddleDetail"} >
                        <div style={{verticalAlign: 'middle',display: 'table-cell'}}>
                            <p >All staff have Zoom accounts with usernames that are the same as their HKMU email addresses (e.g. abc@hkmu.edu.hk). If you are a new staff member, you will receive an invitation email before the start of a new semester. If you do not receive it, please follow the instructions below to activate your account:</p>
                            <ol>
                                <li>
                                    <p  >
                                        Visit <a href="https://zoom.us">https://zoom.us</a>.
                                    </p>
                                </li>
                                <li>
                                    <p >
                                        Click ‘Sign in’.
                                    </p>
                                </li>
                                <li>
                                    <p >
                                        Click ‘Forgot password’.
                                    </p>
                                </li>
                                <li>
                                    <p >
                                        Enter your HKMU email address and click ‘I'm not a robot’.
                                    </p>
                                </li>
                                <li>
                                    <p  >
                                        Click ‘Send’.
                                    </p>
                                </li>
                            </ol>
                            <br/>
                            <p >Zoom meetings are automatically created for all classes according to their schedules. To record your classes, please follow the steps below at the beginning of each class.</p>
                            <ol>
                                <li>
                                    <p  >
                                        Launch the Zoom application installed in Windows
                                    </p>
                                </li>
                                <li>
                                    <p >
                                        Log in to the Zoom application with your own Zoom account. If you have found that someone else has signed in, sign out first. <br/>
                                        <a href={Image.Word.image059} data-lightbox="ZoomRecording" >
                                            <img border={0} width={500} height={'auto'} src={Image.Word.image059} />
                                        </a>
                                    </p>
                                </li>
                                <li>
                                    <p >
                                        Log in to the OLE using the PC in the classroom.
                                    </p>
                                </li>
                                <li>
                                    <p  >
                                    Every classroom should already have a camera and microphone installed. <br/>
                                        <span >
                                        <a href={Image.Word.image060} data-lightbox="ZoomRecording" >
                                            <img border={0} width={480} height={'auto'} src={Image.Word.image060} />
                                        </a>
                                        </span>
                                    </p>
                                    <p>
                                        <span >
                                        <a href={Image.Word.image062} data-lightbox="ZoomRecording" >
                                            <img border={0} width={350} height={'auto'} src={Image.Word.image062} />
                                        </a>
                                        </span>
                                    </p>
                                </li>
                                <li>
                                    <p  >
                                        Click the ‘Join’ button in the ‘Upcoming Classes’ block to launch Zoom.
                                    </p>
                                </li>
                                <li>
                                    <p  >
                                        Make sure that the word ‘Recording…’ and a cloud icon are displayed in the upper-left corner — they indicate that cloud recording is taking place.
                                        <a href={Image.Word.image064} data-lightbox="ZoomRecording" >
                                            <img border={0} width={230} height={'auto'} src={Image.Word.image064} />
                                        </a>
                                    </p>
                                </li>
                            </ol>
                            <p>
                                <span >
                               
                                
                                
                                </span>
                            </p>
                            <p >After recording, the videos will be available on the OLE the next day. Students will not be able to view them until they are released by the teaching staff.</p>
                            <p >
                                
                            </p>
                            <p >You may release the recordings one by one.
                            </p>
                            <p >
                                <span >
                                <a href={Image.Word.image066} data-lightbox="ZoomRecording" >
                                    <img border={0} width={480} height={'auto'} src={Image.Word.image066} />
                                </a>
                                </span>
                                <span>
                                
                                </span>
                            </p>
                            <p >
                                <span>Alternatively,</span>
                                <span> you can choose to release them automatically with immediate effect.</span>
                               
                            </p>
                            <p >
                                <span >
                                <a href={Image.Word.image068} data-lightbox="ZoomRecording" >
                                    <img border={0} width={350} height={'auto'} src={Image.Word.image068} />
                                </a>
                                </span>
                                <span>
                                
                                </span>
                            </p>
                            <p >
                                <span>
                                
                                </span>
                            </p>
                            <p >
                                <span>
                                
                                </span>
                            </p>
                            <p >For more information on Zoom operation, please refer to our Zoom user guide:</p>
                            <p >
                                <a href="https://ole.hkmu.edu.hk/VIP/freebooks.nsf/0/CFD3656823B64C0A48258583000C4906/$File/HKMU_Zoom_Staff_UserGuide_v11-Mar2022.pdf">Zoom User Guide for HKMU Staff.pdf</a>
                                
                            </p>
                            <p >
                                
                            </p>
                        </div>
                    </div>
                    <NavBtn prevItem='/assignment' nextItem='/teaching-tools'/>
                </div>
                
            </div>
            
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default CoursePage;
export default connect(mapStateToProps)(ZoomRecording);